module.exports = __webpack_public_path__ + "img/lightning.0b858a8.webp";